import request from '@/utils/request'

/**
 * 获取用户填报列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function getMyReports(params) {
  return request({
    url: '/health-form-user/my-reports',
    method: 'post',
    data: params
  })
}

/**
 * 获取当日填报状态和数量
 * @returns {Promise} 返回今日填报状态和待填报数量
 */
export function getDailyReportStatus() {
  return request({
    url: '/health-forms/available',
    method: 'get'
  })
}

/**
 * 获取待审批列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function getPendingApproval(params) {
  return request({
    url: '/health-form-user/pending-approval',
    method: 'post',
    data: params
  })
}

/**
 * 获取健康台账分页数据
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function getHealthRecordPage(params) {
  return request({
    url: '/health-form-user/page',
    method: 'post',
    data: params
  })
}

/**
 * 获取健康表单用户填报详情
 * @param {number} id 填报ID
 * @returns {Promise}
 */
export function getHealthFormUserDetail(id) {
  return request({
    url: `/health-form-user/${id}`,
    method: 'get'
  })
}

/**
 * 获取表单初始化数据
 * @param {number} formId 表单ID
 * @param {number} classId 班组ID (可选)
 * @returns {Promise}
 */
export function initHealthFormUser(formId, classId) {
  const params = {}
  if (classId) {
    params.classId = classId
  }
  
  return request({
    url: `/health-form-user/init/${formId}`,
    method: 'get',
    params
  })
}

/**
 * 提交健康表单
 * @param {Object} data 表单数据
 * @returns {Promise}
 */
export function submitHealthFormUser(data) {
  return request({
    url: '/health-form-user/submit',
    method: 'post',
    data
  })
}

/**
 * 审批健康表单
 * @param {number} id 填报ID
 * @param {number} status 审批状态(2:通过, 9:驳回)
 * @returns {Promise}
 */
export function approveHealthFormUser(id, status) {
  return request({
    url: `/health-form-user/approve/${id}/${status}`,
    method: 'post'
  })
}

/**
 * 批量审批健康表单
 * @param {Array<number>} ids 填报ID列表
 * @param {number} status 审批状态(2:通过, 9:驳回)
 * @returns {Promise}
 */
export function batchApproveHealthFormUser(ids, status) {
  return request({
    url: `/health-form-user/batch-approve/${status}`,
    method: 'post',
    data: ids
  })
}

/**
 * 一键全部审批（审批当前用户有权限的所有待审批记录）
 * @param {number} status 审批状态(2:通过, 9:驳回)
 * @returns {Promise}
 */
export function approveAllHealthFormUser(status) {
  return request({
    url: `/health-form-user/approve-all/${status}`,
    method: 'post'
  })
}

/**
 * 导出健康台账数据
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function exportHealthRecord(params) {
  return request({
    url: '/health-form-user/export',
    method: 'post',
    data: params,
    responseType: 'blob'
  })
}

/**
 * 重新提交被驳回的健康表单
 * @param {number} originalId 原记录ID
 * @param {Object} formData 新表单数据
 * @returns {Promise}
 */
export function resubmitHealthFormUser(originalId, formData) {
  return request({
    url: '/health-form-user/resubmit',
    method: 'post',
    data: {
      id: originalId,
      formData: formData
    }
  })
}

/**
 * 获取当前用户待审核表单数量
 * @returns {Promise}
 */
export function getPendingApprovalCount() {
  return request({
    url: '/health-form-user/pending-count',
    method: 'get'
  })
} 